import { ITipoAgendamento } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoAgendamento/TipoAgendamentoInterface";
import {
    AtualizarTipoAgendamentoService,
    CadastrarTipoAgendamentoService,
    DeletarTipoAgendamentoService,
    ListarTipoAgendamentoService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoAgendamento/TipoAgendamentoServices";
import { Controller } from "../../../Controller";

export async function ListarTipoAgendamentoController() {
    return Controller(ListarTipoAgendamentoService());
}

export async function CadastrarTipoAgendamentoController(
    requestBody: ITipoAgendamento
) {
    return Controller(CadastrarTipoAgendamentoService(requestBody));
}

export async function AtualizarTipoAgendamentoController(
    requestBody: ITipoAgendamento
) {
    return Controller(AtualizarTipoAgendamentoService(requestBody));
}

export async function DeletarTipoAgendamentoController(
    idTipoAgendamento: number
) {
    return Controller(DeletarTipoAgendamentoService(idTipoAgendamento));
}
